import Vue from 'vue'
import App from './App.vue'
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery; // 挂载到全局
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.$appUrl = 'https://api.myidoo.com';
Vue.prototype.$uploadUrl = 'https://files.myidoo.com';
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
